export default class InputPasswordShow {

    constructor() {
        if(this.container1 = document.querySelector(".input-show-password-1")) {
            this.input1 = this.container1.querySelector("input");
            this.iconShow1 = this.container1.querySelector(".icon-eye-outline");
            this.iconHide1 = this.container1.querySelector(".icon-eye-off-outline");

            this.iconShow1.addEventListener("click", () => {
                this.iconShow1.style.display = "none";
                this.iconHide1.style.display = "block";
                this.input1.type = "text";
            })

            this.iconHide1.addEventListener("click", () => {
                this.iconHide1.style.display = "none";
                this.iconShow1.style.display = "block";
                this.input1.type = "password";
            })
        }

        if(this.container2 = document.querySelector(".input-show-password-2")) {
            this.input2 = this.container2.querySelector("input");
            this.iconShow2 = this.container2.querySelector(".icon-eye-outline");
            this.iconHide2 = this.container2.querySelector(".icon-eye-off-outline");

            this.iconShow2.addEventListener("click", () => {
                this.iconShow2.style.display = "none";
                this.iconHide2.style.display = "block";
                this.input2.type = "text";
            })

            this.iconHide2.addEventListener("click", () => {
                this.iconHide2.style.display = "none";
                this.iconShow2.style.display = "block";
                this.input2.type = "password";
            })
        }

        if(this.container3 = document.querySelector(".input-show-password-3")) {
            this.input3 = this.container3.querySelector("input");
            this.iconShow3 = this.container3.querySelector(".icon-eye-outline");
            this.iconHide3 = this.container3.querySelector(".icon-eye-off-outline");

            this.iconShow3.addEventListener("click", () => {
                this.iconShow3.style.display = "none";
                this.iconHide3.style.display = "block";
                this.input3.type = "text";
            })

            this.iconHide3.addEventListener("click", () => {
                this.iconHide3.style.display = "none";
                this.iconShow3.style.display = "block";
                this.input3.type = "password";
            })
        }
    }
}